import{styled as r}from"@mui/joy";import i from"@mui/joy/Stack";import o from"@mui/joy/Box";var t=r(i)`
  min-width: 250px;
  width: 250px;
`,m=r(o)`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr ${({hasExtraColumn:r})=>r?"1fr":""};
`;export{m as StyledPermissionAccessControlContainer,t as StyledPermissionHeaderTitle};
//# sourceMappingURL=styles.js.map